import img from "../US_img/13Façade architecturale moderne de la gare Rabat Agdal avec habillage et éclairage intégré.webp"; // adapte le chemin image
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsLightArchitecturale() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>LIGHT</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Éclairage architectural</h1>

          <p data-aos="fade-up">
            Solutions d’éclairage architectural intégrées aux plafonds et murs
            tendus, conçues pour valoriser les volumes et améliorer le confort
            visuel dans les espaces modernes.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-light-architectural.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Light éclairage architectural" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US LIGHT architecturale ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US LIGHT architectural permet l’intégration de systèmes LED
            directement dans les plafonds et murs tendus afin de créer
            des lignes lumineuses ou des surfaces éclairantes.
          </p>

          <p data-aos="fade-up">
            Cette solution met en valeur l’architecture, améliore la
            lisibilité des volumes et garantit un confort visuel optimal
            dans les espaces résidentiels et professionnels.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="🏗️"
            title="Mise en valeur des volumes"
            text="Accentue les formes et lignes architecturales."
          />
          <Feature
            icon="💡"
            title="Lumière uniforme"
            text="Diffusion homogène sans zones d’ombre."
          />
          <Feature
            icon="🎯"
            title="Confort visuel"
            text="Éclairage doux et agréable pour les utilisateurs."
          />
          <Feature
            icon="⚙️"
            title="Intégration discrète"
            text="Systèmes lumineux intégrés sans éléments visibles."
          />
          <Feature
            icon="⚡"
            title="LED économiques"
            text="Faible consommation énergétique."
          />
          <Feature
            icon="🛠️"
            title="Maintenance simple"
            text="Accès technique facilité et composants remplaçables."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Lignes lumineuses LED intégrées</li>
          <li>Plafonds et murs lumineux</li>
          <li>Température de couleur maîtrisée</li>
          <li>Diffusion homogène sans éblouissement</li>
          <li>Structure aluminium technique</li>
          <li>Compatible projets architecturaux modernes</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Bureaux",
            "Centres commerciaux",
            "Gares",
            "Hôtels",
            "Restaurants",
            "Espaces résidentiels",
            "Musées",
            "Espaces publics",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Valorisez votre architecture par la lumière</h2>
        <p>Nos solutions US LIGHT s’adaptent à tous vos projets.</p><br/>
        <a href="/contact" className="btn-primarya">Contactez-nous</a>
      </section>

    </div>
  );
}
